import React, { useState } from "react";

//UI Material
import {
  Button,
  Card,
  CircularProgress,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

//Local components
import SetItemDrawer from "../drawers/SetItemDrawer";
import ModalWindow from "../Modal";

//Material Icons
import { Delete, Edit } from "@mui/icons-material";

export default function ItemInfo({ data, getItem }) {
  // ==========>Component States<==========
  //State for open/close drawer for set product
  const [openDrawer, setOpenDrawer] = useState(false);
  //State for loading in delete request
  const [isLoading, setIsLoading] = useState(false);
  //State for error in delete request
  const [isError, setIsError] = useState(false);
  //Open modal for delete confirmation/response
  const [openModal, setOpenModal] = useState(false);

  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container sx={{ padding: "20px" }} spacing={1}>
        <SetItemDrawer
          open={openDrawer}
          setOpen={setOpenDrawer}
          existingItemData={data}
          getData={getItem}
          isNewItem={false}
        />
        <Grid item xs={12} align="left">
          <Typography variant="h6" fontWeight="bold">
            Información del ítem
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12} align="left">
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Información principal del ítem
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Nombre del ítem
            </Typography>
            <Typography variant="body2">{data.name}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Identificador del ítem
            </Typography>
            <Typography variant="body2">{data.id}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Tipo de ítem
            </Typography>
            <Typography variant="body2">{data.category}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Estante
            </Typography>
            <Typography variant="body2">{data.location}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Especificaciones del ítem
            </Typography>
            <Typography variant="body2">{data.specifications}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Identificador adicional
            </Typography>
            <Typography variant="body2">{data.additionalCode}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12} align="left">
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Disponibilidad del ítem
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Stock disponible
            </Typography>
            <Typography variant="body2">{data.availableStock}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Stock recomendado
            </Typography>
            <Typography variant="body2">{data.recommendedStock}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Frecuencia de re-stock
            </Typography>
            <Typography variant="body2">{data.restockFrequency}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Stock histórico
            </Typography>
            <Typography variant="body2">{data.historyStock}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12} align="left">
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Información sobre la venta del ítem
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Precio estimado de venta
            </Typography>
            <Typography variant="body2">
              {data.estimatedPriceOfSale || "Sin especificar"}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Tipo de moneda
            </Typography>
            <Typography variant="body2">
              {data.currency || "Sin especificar"}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12} align="right">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
          >
            <Button
              variant="contained"
              color="secondary"
              size="small"
              sx={{ color: "white" }}
              endIcon={<Edit />}
              onClick={() => {
                setOpenDrawer(true);
              }}
            >
              EDITAR ítem
            </Button>
            {isLoading ? (
              <CircularProgress size={25} />
            ) : (
              <Button
                variant="contained"
                size="small"
                color="error"
                sx={{ color: "white" }}
                endIcon={<Delete />}
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                Remover ítem
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={openModal}
        handleClose={() => {
          setOpenModal(false);
        }}
        leftText="Cancelar"
        leftClick={() => {
          setOpenModal(false);
        }}
        rightText="Sí, Remover"
        rightColor="error"
        //rightClick={deleteProduct}
        title="Remover ítem"
        text="¿Desea remover este ítem permanentemente del sistema?"
      />
      <ModalWindow
        isOpen={isError}
        handleClose={() => {
          setIsError(false);
        }}
        leftText="Ok"
        leftClick={() => {
          setIsError(false);
        }}
        title="No se pudo realizar la acción"
        text="No se pudo remover el ítem, por favor intente nuevamente."
      />
    </Card>
  );
}
